import { jsx as a, jsxs as X } from "react/jsx-runtime";
import { forwardRef as V, useState as f, useRef as E, useEffect as g, useMemo as P, useCallback as H, useImperativeHandle as W } from "react";
import { createPortal as ee } from "react-dom";
import { createRoot as te } from "react-dom/client";
import l from "./styles.module.less.js";
import { useDisableScroll as oe } from "../../../utils/use-disable-scroll.js";
const ne = "user-info-atticus", K = V(
  ({
    defaultOpen: p = !1,
    onClose: u,
    onOpen: o,
    iframeUrl: s,
    category: d = null,
    suburb: m = null,
    suburbUrl: w = null,
    utmContent: C,
    fromFirm: h,
    additionalParams: n = {},
    ga4MeasurementId: r,
    onIframeLoad: S,
    onCloseWithData: M,
    source: B = "lawconnect",
    user: y,
    context: R
  }, Y) => {
    const [_, G] = f(p), [N, $] = f(!1), [I, x] = f(!1), [L, Z] = f(""), [j, z] = f(""), T = E(null), i = E(null), D = E(""), [k, F] = f(!1);
    oe({ isDisabled: _ }), g(() => {
      (() => {
        if (typeof window < "u" && window.gtag)
          try {
            if (r) {
              window.gtag(
                "get",
                r,
                "client_id",
                (e) => {
                  e && Z(e);
                }
              ), window.gtag(
                "get",
                r,
                "session_id",
                (e) => {
                  e && z(e);
                }
              );
              return;
            }
          } catch (e) {
            console.warn("Failed to get GA4 data from gtag:", e);
          }
      })();
    }, [r]);
    const b = P(() => {
      const t = new URLSearchParams();
      Object.entries(n).forEach(([c, A]) => {
        c !== "client_id" && c !== "session_id" && t.append(c, A);
      }), L && t.append("client_id", L), j && t.append("session_id", j);
      const e = t.toString();
      return `${s}${e ? `?${e}` : ""}`;
    }, [s, n, L, j]);
    g(() => {
      b !== D.current && x(!1), D.current = b;
    }, [b]);
    const J = H(() => {
      i.current && (clearTimeout(i.current), i.current = null), $(!1), G(!0), o == null || o();
    }, [o]), v = H(() => {
      i.current && clearTimeout(i.current), $(!0), i.current = setTimeout(() => {
        G(!1), $(!1), u == null || u();
      }, 200);
    }, [u]);
    g(() => () => {
      i.current && clearTimeout(i.current);
    }, []);
    const O = () => {
      x(!0), S == null || S();
    };
    g(() => {
      _ && I && setTimeout(() => {
        var t;
        if (T.current) {
          const e = {
            type: "init-atticus",
            payload: {
              category: d || null,
              suburb: w || m || null,
              ...h ? { fromFirm: h } : {},
              utm: {
                utmSource: n.utm_source || void 0,
                utmContent: C || void 0,
                utmCampaign: n.utm_campaign || void 0,
                utmMedium: n.utm_medium || void 0,
                utmTerm: n.utm_term || d || void 0,
                gclid: n.gclid || void 0,
                gaClientId: L || void 0
              },
              source: B,
              sourceUrl: window.location.href,
              // Include all stored query string parameters
              queryParams: n,
              // Include context if provided
              ...R ? { context: R } : {}
            }
          };
          try {
            F(!0), (t = T.current.contentWindow) == null || t.postMessage(e, "*");
          } catch (c) {
            console.error("❌ Error sending postMessage:", c);
          }
        }
      }, 100);
    }, [
      _,
      I,
      d,
      m,
      w,
      C,
      h,
      n,
      B,
      R
    ]);
    const q = E(!1);
    return g(() => {
      var t, e;
      if (k && y && !q.current) {
        q.current = !0;
        const c = {
          type: ne,
          name: y.name,
          email: y.email,
          phone: y.phone
        };
        (e = (t = T.current) == null ? void 0 : t.contentWindow) == null || e.postMessage(c, "*");
      }
    }, [k, y]), g(() => {
      const t = (e) => {
        var c, A, U;
        if (console.log("event", e), ((c = e.data) == null ? void 0 : c.type) === "close-atticus") {
          console.log("event.data", e.data);
          const Q = {
            email: (A = e.data) == null ? void 0 : A.email,
            jobId: (U = e.data) == null ? void 0 : U.jobId
          };
          M == null || M(Q), v();
        }
      };
      return window.addEventListener("message", t), () => {
        window.removeEventListener("message", t);
      };
    }, [v, M]), W(Y, () => ({
      openModal: J,
      closeModal: v
    })), !_ && !N ? null : ee(
      /* @__PURE__ */ a(
        "div",
        {
          className: `${l.modal} ${N ? l.closing : ""}`,
          onClick: v,
          children: /* @__PURE__ */ X(
            "div",
            {
              className: `${l.modalContent} ${N ? l.closing : ""}`,
              onClick: (t) => t.stopPropagation(),
              children: [
                /* @__PURE__ */ a("div", { className: l.close, onClick: v, children: /* @__PURE__ */ a(
                  "svg",
                  {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /* @__PURE__ */ a(
                      "path",
                      {
                        d: "M19.5 3.75C19.9142 3.75 20.25 4.08579 20.25 4.5C20.25 4.70708 20.1661 4.89456 20.0304 5.03028L13.0607 12L20.0304 18.9696C20.1661 19.1054 20.25 19.2929 20.25 19.5C20.25 19.9142 19.9142 20.25 19.5 20.25C19.2894 20.25 19.099 20.1632 18.9628 20.0233L12.0001 13.0606L5.03039 20.0303C4.89466 20.166 4.70713 20.25 4.5 20.25C4.08579 20.25 3.75 19.9142 3.75 19.5C3.75 19.2912 3.83535 19.1023 3.97308 18.9663L10.9394 12L3.97671 5.03727C3.83685 4.90104 3.75 4.71066 3.75 4.5C3.75 4.08579 4.08579 3.75 4.5 3.75C4.70711 3.75 4.89462 3.83395 5.03034 3.96968L12.0001 10.9393L18.9663 3.97308C19.1023 3.83535 19.2912 3.75 19.5 3.75Z",
                        fill: "#B0B7BD"
                      }
                    )
                  }
                ) }),
                !I && /* @__PURE__ */ a("div", { className: l.loadingSpinner, children: /* @__PURE__ */ a("div", { className: l.spinner }) }),
                /* @__PURE__ */ a(
                  "iframe",
                  {
                    ref: T,
                    src: b,
                    width: "100%",
                    height: "100%",
                    onLoad: O,
                    className: l.iframe,
                    title: "Atticus AI Assistant",
                    style: { opacity: I ? 1 : 0 }
                  }
                )
              ]
            }
          )
        }
      ),
      document.body
    );
  }
);
K.displayName = "AtticusModal";
const de = (p, u = !1) => {
  const o = document.createElement("div");
  document.body.appendChild(o);
  const s = { current: null };
  let d = !1;
  const m = te(o), w = () => {
    d && s.current ? s.current.openModal() : setTimeout(() => w(), 0);
  }, C = () => {
    d && s.current && s.current.closeModal();
  }, h = () => {
    if (s.current)
      s.current.closeModal(), setTimeout(() => {
        try {
          m.unmount(), document.body.contains(o) && document.body.removeChild(o);
        } catch (r) {
          console.error("Error destroying modal:", r);
        }
      }, 300);
    else
      try {
        m.unmount(), document.body.contains(o) && document.body.removeChild(o);
      } catch (r) {
        console.error("Error destroying modal:", r);
      }
  }, n = {
    ...p,
    defaultOpen: u,
    // Set defaultOpen based on immediate flag
    ref: (r) => {
      r && (s.current = r, d = !0);
    },
    // Ensure we properly handle the onClose event
    onClose: () => {
      p.onClose && p.onClose();
    }
  };
  return m.render(/* @__PURE__ */ a(K, { ...n })), {
    open: w,
    close: C,
    destroy: h
  };
};
export {
  K as AtticusModal,
  de as createAtticusModal
};
